import { Card } from '@optools/components/ui/card';
import { MediaPipeline } from '@optools/services/operator-gateway/types/generated/graphql';
import { Projector } from 'lucide-react';

import { EVIPodsSelect } from './evi-pods-select';
import { EVIStatusSwitch } from './evi-status-switch';

export interface EVIControlsProps extends Pick<MediaPipeline, 'eviPod' | 'eviStatus'> {
  mediaId: string;
  pipelineStatus: MediaPipeline['status'];
}

export function EVIControls({ eviPod, eviStatus, mediaId, pipelineStatus }: EVIControlsProps) {
  return (
    <Card className="flex flex-col items-start justify-between gap-6 p-4">
      <div className="flex items-center gap-2">
        <div className="rounded border border-accent-foreground/70 p-1">
          <Projector className="size-4" />
        </div>
        <h2 className="font-bold">EVI</h2>
      </div>

      <div className="flex flex-col gap-2" data-testid="evi">
        <div className="flex gap-4">
          <EVIStatusSwitch eviStatus={eviStatus} mediaId={mediaId} status={pipelineStatus} />
          <EVIPodsSelect eviPod={eviPod} mediaId={mediaId} status={pipelineStatus} />
        </div>
      </div>
    </Card>
  );
}
